import { Box, Button, ButtonProps } from "@mui/material";
import { BOTTOM_BUTTONS } from "../types/dart";
import { styled } from "@mui/material/styles";
import colors from "../theme/colors";
import fonts from "../theme/fonts";
import { KEYBOARD_KEY } from "../types/keyboardKeys";
import { useContext, useEffect } from "react";
import { OnlineMatchContext } from "../contexts/OnlineMatchContext";

interface BottomButtonProps {
  undoHandler: Function;
  onClickHandler: Function;
  botTurn: boolean;
  inUndoState: boolean;
}

export default function BottomButtons({
  undoHandler,
  onClickHandler,
  botTurn,
  inUndoState,
}: BottomButtonProps) {
  const {online} = useContext(OnlineMatchContext);
  useEffect(() => {
    function handleKeyUp({ key }: any) {
      if (key === KEYBOARD_KEY.BACKSPACE) {
        undoHandler();
        return;
      }
      if (key === KEYBOARD_KEY.ENTER || key === KEYBOARD_KEY.SPACE) {
        onClickHandler(BOTTOM_BUTTONS.MISS, BOTTOM_BUTTONS.MISS);
        return;
      }
      if (key === KEYBOARD_KEY.ESCAPE) {
        onClickHandler(BOTTOM_BUTTONS.END_TURN, BOTTOM_BUTTONS.END_TURN);
        return;
      }
    }
    document.addEventListener("keyup", handleKeyUp);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener("keyup", handleKeyUp);
    };
    // eslint-disable-next-line
  }, [onClickHandler]);

  return (
    <Box
      display="grid"
      gridTemplateColumns="1fr 1fr 1fr"
      width="100%"
      height="90%"
      gap="7px"
      style={{ placeItems: "center" }}
    >
      <EndButton
        disabled={botTurn}
        variant="contained"
        onClick={() =>
          onClickHandler(BOTTOM_BUTTONS.END_TURN, BOTTOM_BUTTONS.END_TURN)
        }
      >
        End Turn
      </EndButton>
      <MissButton
        disabled={botTurn}
        variant="contained"
        onClick={() => onClickHandler(BOTTOM_BUTTONS.MISS, BOTTOM_BUTTONS.MISS)}
      >
        Miss
      </MissButton>
      <UndoButton
        disabled={botTurn && !inUndoState && !online}
        variant="contained"
        onClick={() => undoHandler()}
      >
        Undo
      </UndoButton>
    </Box>
  );
}

const BaseButton = styled(Button)<ButtonProps>(() => ({
  color: colors.darkGray,
  fontFamily: fonts.family.nice,
  height: "100%",
  width: "95%",
  backgroundColor: "#92b19c",
  fontSize: fonts.size.mediumLarge,
  textTransform: "none",
  "@media(max-width: 1000px)": {
    fontSize: fonts.size.mediumLarge,
    // height: "100px",
  },
  "@media(max-width: 650px)": {
    fontSize: fonts.size.medium,
    height: "50px",
  },
}));

const EndButton = styled(BaseButton)<ButtonProps>(() => ({
  "&:hover": {
    backgroundColor: "#C56262",
  },
}));

const MissButton = styled(BaseButton)<ButtonProps>(() => ({
  "&:hover": {
    backgroundColor: "#CDA9B9",
  },
}));

const UndoButton = styled(BaseButton)<ButtonProps>(() => ({
  "&:hover": {
    backgroundColor: "#C7AB8D",
  },
}));
